import React from 'react'

interface ILabel {
  className?: string
  htmlFor?: string
  required?: boolean
  text: string
  handleLabelClick?: () => void
}

const Label = ({
  className = '',
  htmlFor,
  required = false,
  text = '',
  // tslint:disable-next-line
  handleLabelClick = () => {}
}: ILabel) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`font-black2 text-sm weight-500 ${className}`}
      onClick={() => handleLabelClick()}
    >
      {text}
      {required && <span className='font-red text-md'> *</span>}
    </label>
  )
}

export default Label



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/common/Label.tsx